import React, { Component } from 'react';

class Radio extends Component {
    render() {
        return (
            <div className="pp-input-wrapper pp-radio-wrapper">
                <label
                    className="pp-input-label"
                    htmlFor={ this.props.htmlID }>
                        { this.props.label }
                </label>
                <input
                    type="radio"
                    checked={ this.props.checked }
                    id={ this.props.htmlID }
                    name={ this.props.htmlName }
                    className="pp-radio"
                    defaultValue={ this.props.defaultValue }
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Radio.js